import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  icon?: string;
  id: string;
  isOpen: boolean;
  onToggle: () => void;
  summary?: ReactNode;
  title: string;
};

function FilterSection({ children, icon, id, isOpen, onToggle, summary, title }: Readonly<Props>) {
  return (
    <div className="filters__section">
      <button
        aria-controls={`${id}-content`}
        aria-expanded={isOpen}
        className="filters__sectionHeader"
        id={`${id}-header`}
        onClick={onToggle}
        type="button"
      >
        {icon && <i aria-hidden="true" className={icon} />}
        <span className="filters__sectionTitle">{title}</span>
        {summary}
        <i
          aria-hidden="true"
          className={`fa-solid fa-chevron-down filters__sectionChevron${isOpen ? ' filters__sectionChevron--open' : ''}`}
        />
      </button>
      {isOpen && (
        <div aria-labelledby={`${id}-header`} className="filters__sectionContent" id={`${id}-content`} role="region">
          {children}
        </div>
      )}
    </div>
  );
}

export default FilterSection;
